import { render, staticRenderFns } from "./ProcessosJudiciaisForm.vue?vue&type=template&id=73536769&scoped=true&"
import script from "./ProcessosJudiciaisForm.vue?vue&type=script&lang=js&"
export * from "./ProcessosJudiciaisForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcessosJudiciaisForm.vue?vue&type=style&index=0&id=73536769&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73536769",
  null
  
)

export default component.exports